/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import React, {PureComponent} from 'react';
import Connection from "../../../models/connectionModel";
import AdminConnections from "./adminConnections";

interface State {
    connections: Connection[];
}

const PING_TIMEOUT = 300000; // Every 5 minutes

export default class AdminConnectionsController extends PureComponent<any, State> {
    private pingTimeout: number;

    state: State = {
        connections: [],
    };

    getConnections = () => {
        Connection.getAll((connections: Connection[], success: boolean) => {
            if (success)
                this.setState({connections});
        });
        this.pingTimeout = window.setTimeout(this.getConnections, PING_TIMEOUT);
    };

    componentDidMount = () => {
        this.getConnections();
    };

    componentWillUnmount = () => {
        if (this.pingTimeout) window.clearTimeout(this.pingTimeout);
    };

    render = () => {
        const {connections} = this.state;
        return <AdminConnections connections={connections}/>;
    }
}